<!-- 按钮 -->
<template>
  <el-button :style="style" :type="type" :plain="plain">
    <span v-if="typeClass" :class="typeClass"><slot></slot></span>
    <template v-else="">
      <slot></slot>
    </template>
  </el-button>
</template>

<script>
  export default {
    props:{
      typeClass:{
        value:String,
      },
      type:{
        value:String,
        default:""
      },
      plain:{
        value:Boolean,
        default:true
      },
      width:{
        value:Number|String
      },
      height:{
        value:Number|String
      }
    },
    computed: {
      style: function () {
        let style = "";
        if(this.width){
          style +="width:"+this.width+"px;"
        }
        if(this.height){
          style +="height:"+this.height+"px;"
        }
        return style;
      },
    },
    name: 't-button',
    data () {
      return {
      }
    },
    mixins: [tableBase],
    methods: {
      clickBtn(e){
        this.$emit('click')
      }
    },
    mounted () {
    }
  }
</script>

<style lang="less" scoped>

</style>
